import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

/*!*******************************************************************************!
  !*** MANAGE TAX COMPONENTS API CONFIG                                                       ***!
  \*******************************************************************************/

export const apiConfig = {
  // Clients: BOM.baseUrl("clients"),
  Clients: BOM.baseUrl("clients", "wallet"),
  Client: BOM.baseUrl("client", "wallet"),
  FixedDepositAccounts: BOM.baseUrl("fixeddepositaccounts"),
  FixedDepositPreview: BOM.baseUrl("fixeddepositaccounts/preview"),
  LoanAccounts: BOM.baseUrl("loans"),
  savingsAccounts: BOM.baseUrl("savingsaccounts"),
  standingInstruction: BOM.baseUrl("standinginstruction"),
  standingInstructions: BOM.baseUrl("standinginstructions"),
  relationship: BOM.baseUrl("familymembers"),
  charges: BOM.baseUrl("charges"),
  accounts: BOM.baseUrl("accounts"),
  Search: BOM.baseUrl("search", "wallet"),
  ClientLimit: BOM.baseUrl("client-limit"),
  Savings: BOM.baseUrl("savings"),
  Journalentries: BOM.baseUrl("journalentries"),
  detailJournalEntry: BOM.baseUrl(
    "journalentries?transactionDetails=true&transactionId",
  ),
  JournalEntries: BOM.baseUrl("journalentries"),
  Offices: BOM.baseUrl("offices"),
  GlAccounts: BOM.baseUrl("glaccounts"),
  rescheduleloans: BOM.baseUrl("rescheduleloans"),
  savingsAccountDetails: BOM.baseUrl("savingsaccountdetails"),

  //CURRENT ACCOUNT
  AccountTransfers: BOM.baseUrl("accounttransfers"),
  Codes: BOM.baseUrl("codes"),
  rovapassfortAccount: BOM.baseUrl("rovapassfortAccount"),
  fxtransactions: BOM.baseUrl("fxtransactions"),
  savingsaccountdetails: BOM.baseUrl("savingsaccountdetails"),
  //END OF CURRENT ACCOUNT

  Recurringdepositaccounts: BOM.baseUrl("recurringdepositaccounts"),
  FieldConfiguration: BOM.baseUrl("fieldconfiguration", "wallet"),
  Counterparty: BOM.baseUrl("counterparty", "treasury"),
  Counterparty: BOM.baseUrl("counterparty", "treasury"),
  certificates: BOM.baseUrl("certificates", "treasury"),
  treasuryCertificates: BOM.baseUrl("certificates", "treasury"),
  WalletAccount: BOM.baseUrl("walletsaccounts", "wallet"),
};
//
/*!*******************************************************************************!
  !*** CUSTOMER LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const labelConfig = {
  ManageServiceProvider: "Manage Service Provider",
  detailServiceProvider: "Service Provider Details",
  serviceProvider: "Service Provider",
  newServiceProvider: "New Service Provider",
  detailServiceProvider: "Service Provider Detail",
  generalInfo: "General Information",
  currencyInfo: "Currency Information",
  selectedInfo: "Selected Charge Information",
  overdraftInfo: "Overdraft Information",
  interestInfo: "Interest Information",
  currentAccountSetup: "Account Setup",
  editCustomer: "Edit Customer",
  customerSetup: "Customer Setup",
  addressInfo: " Address Information",
  additionalInfo: "Additional Information",
  work: "Work",
  active: "Active",
  status: "Status",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  customerClassification: "Customer Classification",
  staff: "Relationship Manager",
  officer: "Officer",
  isStaff: "Is Staff?",
  dateOfBirth: "Date of Birth",
  identifactionType: "Identification Type",
  identifactionNo: "Identification No.",
  selectCasaProduct: "Select CASA Product",
  walletProduct: "Wallet Product",
  assignDefaultProduct: "Assign Default Product",
  issuingAuthority: "Issuing Authority",
  expiryDate: "Expiry Date",
  submittedOn: "Date Created",
  createdDate: "Created Date",
  addressOne: "Address Line 1",
  addressTwo: "Address Line 2",
  addressThree: "Address 3",
  stateProvince: "State / Province",
  postalCode: "Postal Code",
  street: "Street",
  addressTypeId: "Address Type",
  // streetTwo: "Street 2",
  // streetThree: "Street 3",
  workAdress: "Work Address",
  others: "Others",
  mobileNumber: "Mobile Number",
  kycLevel: "KYC Level",
  kycSuccessfulMsg: "KYC was successfully edited",
  customerClass: "Customer Class",
  agentType: "Agent Type",
  superAgent: "Super Agent",
  assignAgenOrMerchant: "Assign Agent/Merchant",
  customerCategory: "Customer Category",
  upload: "Upload",
  clientNo: "Customer ID",
  fullname: "Full Name",
  documentType: "Document Type",
  deleteDocumentMsg: "Document was successfully deleted",
  casaAccount: "Current and Savings Account(s)",
  casaAccountDetail: "Current and Savings Account Detail",
  loanAccountDetail: "Loan Account Detail",
  LoanAccount: "Loan Account(s)",
  newCustomerMsg: "Customer was successfully created",
  newServiceProviderMsg: "Service Provider was successfully created",
  editCustomerMsg: "Customer was successfully edited",
  deleteCustomerMsg: "Customer was successfully deleted",
  branch: "Branch",
  newAddress: "New Address",
  editAddress: "Edit Address",
  newAddressMsg: "Address was successfully created",
  editAddressMsg: "Address was successfully edited",
  addressSetup: "Address Setup",
  closureReason: "Closure Reason",
  closureDate: "Closure Date",
  charge: "Charge",
  closeLoanAccount: "Close Loan Account",
  customerClosureMsg: "Customer Account is successfully closed",
  cardInfo: "Cards",
  walletInfo: "H/Wallets",
  foreName: "Full Name",
  counterpartParent: "Counterpart Parent",
  relationshipInfo: "Relationship Info",
  establishedRelationshipFlag: "Established Relationship Flag",
  bankOfEnglandIndustryCode: "Bank of England Industry Code",
  centralBankIndustryCode: "Central Bank Industry Code",
  economicActivityCode: "Economic Activity code",
  NACECode: "NACE Code",
  SMEFlag: "SME Flag",
  intercompanyFlag: "Inter Company Flag",
  shortLong: "Short / Long Term Rating",
  creditRating: "Credit Rating",
  centralGovernmentRatingIndicator: "Central Government Rating Indicator",
  institutionWhereClient: "Institution Where Client Money Is Placed",
  frequency: "Frequency Internal Client Reconciliation",
  frequencyExternal: "Frequency External Client Reconciliation",
  treasuryDealersLines: "Treasury Dealers Lines",
  daytimePhoneNo: "Daytime Phone Number",
  addedTaxJurisdiction: "Added Tax Jurisdiction",
  DGSEligible: "DGS Eligible",
  DGSEligibleReason: "DGS Eligible Reason",
  transferType: "Transfer Type",
  fromAccountType: "From Account Type",
  clientName: "Client Name",
  agentId: "Agent Code",
  agentType: "Agent Type",
  toDate: "To Date",
  fromDate: "From Date",
  fromAccountId: "From Account Id",
  viewClosed: "View Closed",
  viewActive: "View Active",
  addressStatus: "Address Status",
  activationDate: "Activation Date",
  email: "Email",
  nationality: "Nationality",
  openCasaAccount: "Open CASA Account?",
  issuingDate: "Issuing Date",
  name: "Name",
  businessName: "Business Name",
  incorporationDate: "Incorporation Date",
  incorporationValidUntil: "Incorporation Valid Until",
  incorporationValidDate: "Incorporation Valid Date",
  incorporationNumber: "Incorporation Number",
  constitution: "Constitution",
  mainBusinessLine: "Main Business Line",
  remarks: "Remarks",
  accountNo: "Account No",
  sourceOfWealth: "Source of Wealth",
  pepStatus: "PEP Status",
  riskRating: "Risk Rating",
  product: "Product",
  productSetup: "Product Setup",
  customer: "Customer",
  loanOfficer: "Loan Officer",
  loanPurpose: "Loan Purpose",
  fund: "Fund",
  disbursementOn: "Disbursement On",
  externalId: "External ID",
  externalID: "External ID",
  businessRegistrationNumber: "Business Registration Number",
  linkSavings: "Link Savings",
  linkAccount: "Link To Account",
  createStandingInstructions: "Create Standing Instructions at Disbursement:",
  repaidEvery: "Repaid Every",
  dayOfWeek: "Day of Week",
  on: "On",
  repaymentFrequency: "Repayment Frequency",
  option: "Option",
  isEqualAmortization: "Is Equal Amortization",
  interestCalculationPeriod: "Interest Calculation Period",
  calculateInterest: "Calculate Interest for Exact Days in Partial Period",
  interestFreePeriod: "Interest Free Period",
  arrearsTolerance: "Arrears Tolerance",
  repaymentStrategy: "Repayment Strategy",
  moratorium: "Moratorium",
  onPrincipalPayment: "On Principal Payment",
  onInterestPayment: "On Interest Payment",
  collateral: "Collateral",
  value: "Value",
  penalInterest: "Penal Interest",
  description: "Description",
  enableManualInterestEntry: "Enable Manual Interest Entry",
  newRelationship: "New Relationship",
  qualification: "Qualification",
  age: "Age",
  isDependent: "Is Dependent?",
  relationshipType: "Relationship",
  profession: "Profession",
  maritalStatus: "Marital Status",
  newRelationshipCreatedMsg: "New Relationship was successfully created",
  editRelationship: "Edit Relationship",
  editRelationshipMsg: "Relationship was successfully edited",
  deleteRelationshipMsg: "Relationship was successfully deleted",
  current: "Current",
  currentAccount: "Current Account",
  currentAccounts: "Current Accounts",
  savings: "Savings",
  savingsAccount: "Savings Account",
  savingsAccounts: "Savings Accounts",
  depositAccount: "Deposit Account",
  fixedDepositAccount: "Fixed Deposit Account",
  recurringDepositAccount: "Recurring Deposit Account",
  depositAccounts: "Deposit Accounts",
  fixedDepositAccounts: "Fixed Deposit Accounts",
  recurringDepositAccounts: "Recurring Deposit Accounts",
  loansAccount: "Loan Account",
  manageLoanAccount: "Manage Loan Account",
  manageDepositAccount: "Manage Deposit Account",
  accounNumber: "Account Number",
  accountName: "Account Name",
  customerId: "Customer ID",
  currentBalance: "Current Balance",
  availableBalance: "Available Balance",
  savingsAccountDetails: "Savings Account Details",
  accountOfficer: "Account Officer",
  maturityDate: "Maturity Date",
  period: "Period",
  periodType: "Period Type",
  performanceHistory: "Performance History",
  principalAmount: "Principal Amount",
  maturityAmount: "Maturity Amount",
  maturityInterest: "Maturity Interest",
  interestEarned: "Interest Earned",
  totalDeposits: "Total Deposits",
  financialInformation: "Financial Information",
  nominalInterestrate: "Nominal Interest Rate",
  interestCompoundingPeriod: "Interest Compounding Period",
  interestPostingPeriod: "Interest Posting Period",
  interestCalculatedUsing: "Interest Calculated Using",
  daysInYear: "Days In Year",
  prelosurePenalInterestLess: "Pre-closure penal Interest (less)",
  reasonForBlockHold: "Reason for Block/Hold",
  balanceOnHold: "Balance OnHold",
  subStatus: "Sub Status",
  currency: "Currency",
  decimalPlaces: "Decimal Places",
  currencyInMultiplesOf: "Currency In Multiples Of",
  norminalAnnualInterest: "Nominal Annual Interest(%)",
  minimumOpeningBalance: "Minimum Opening Balance",
  lockInPeriod: "Lock-In Period",
  lockinPeriodFrequencyType: "Lock-In Period Frequency Type",
  applyWithdrawalFeeForTransfers: "Apply Withdrawal Fee for Transfers",
  isOverdraftAllowed: "Is Overdraft Allowed?",
  maxOverdraftAmountLimit: "Max Overdraft Amount limit",
  nominalAnnualInterestForOverdraft:
    " Nominal Annual Interest Rate For Overdraft",
  minOverdraftRequiredForInterestCalculation:
    "Min Overdraft Required For Interest Calculation",

  isLienAllowed: " Is Lien Allowed",
  maximumLienAmountLimit: "Maximum Lien Amount Limit",
  enforceMinimumBalance: "Enforce Minimum Balance",
  minimumBalance: "Minimum Balance",
  charges: "Charges",
  chargeCalculation: "Charge Calculation",
  chargeCalculationType: "Charge Calculation Type",
  chargeTimeType: "Charge Time Type",
  dueForCollectionOn: "Due For Collection On",
  amount: "Amount",
  limitAmount: "Limit Amount",
  newChargeMsg: "Charge was successfully created",
  editChargeMsg: "Charge was successfully edited",
  deleteChargeMsg: "Charge was successfully deleted",
  reversedChargeMsg: "Charge_Action was successfully Reversed",
  payChargeMsg: "Charge was successfully Payed",
  waivedChargeMsg: "Charge was successfully Waived",
  addInterestRateChart: "Add Interest Rate Chart",
  applicant: "Applicant ",
  type: "Type",
  loansAccounts: "Loans Accounts",
  priority: "Priority",
  fromAccount: "From Account",
  destination: "Destination",
  toBranch: "To Branch",
  toAccountType: "To Account Type",
  toAccount: "To Account",
  standingInstructionType: "Standing Instruction Type ",
  validityFrom: "Validity From",
  to: "Validity Till",
  depositsTillDate: "Deposits Till Date",
  depositsToDate: "Deposits to Date",
  withdrwalsTillDate: "Withdrwals Till Date",
  withdrawalsToDate: "Withdrawals to Date",
  recurrenceType: "Recurrence Type",
  interval: "Interval ",
  recurrenceFrequency: "Recurrence Frequency ",
  onMonthDay: "On Month Day ",
  newStandingInstructionMsg: "Standing Instruction was successfully created",
  editStandingInstructionMsg: "Standing Instruction was successfully edited",
  deleteStandingInstructionMsg: "Standing Instruction was successfully deleted",
  beneficiaryInfo: "Beneficiary Information",
  instructionInfo: "Instruction Information",
  detailStandingInstruction: "Standing Instruction Detail",
  editStandingInstruction: "Edit Standing Instruction",
  standingInstructionSetup: "Standing Instruction Setup",
  detailCharge: "Charge Detail",
  editCharge: "Edit Charge",
  payCharge: "Pay Charge",
  waived: "Waived",
  paid: "Paid",
  outstanding: "Outstanding",
  due: "Due",
  dueAsOf: "Due as Of",
  transactions: "Transactions",
  principal: "Principal",
  loanTerm: "Loan Term",
  firstRepaymentOn: "First Repayment On",
  interestMethod: "Interest Method",
  newLoanAccountMsg: "Loan Account was successfully created",
  sysErrorMsg: "Sys-Error 20011 - Admin Has Been Notified",
  loanTrancheDetails: "Loan Tranche Details",
  recalculateInterest: "Recalculate Interest",
  daysinYear: "Days In Year",
  advancePayments: "Advance Payments Adjustment Type",
  daysInMonth: "Days In Month",
  interestRecalculationCompounding: "Interest Recalculation Compounding On",
  FrequencyForRecalculate: "Frequency For Recalculate Outstanding Principal",
  maximumAllowedOutstanding: "Maximum Allowed Outstanding Balance",
  customerInfo: "Customer ID",
  refresh: "Refresh",
  customerNumber: "Customer Number",
  customerName: "Customer Name",
  loanPrepayment: "Loan Prepayment",
  addLoanCharge: "Add Loan Charge",
  assignLoanOfficer: "Assign Loan Officer",
  foreClosure: "Foreclosure",
  makeRepayment: "Make Repayment",
  undoDisbursal: "Undo Disbursal",
  undoApproval: "Undo Approval",
  waiveInterest: "Waive Interest",
  reschedule: "Reschedule Loan",
  rescheduleRequest: "Loan Reschedule Request",
  writeOff: "Write Off Loan Account",
  close: "Close",
  closed: "Closed",
  closeAsRescheduled: "Close As Rescheduled",
  loanScreenReports: "Loan Screen Reports",
  viewGuarantors: "View Guarantors",
  createGuarantor: "Create Guarantor",
  recoverFromGuarantor: "Recover From Guarantor",
  transactionAmount: "Transaction Amount",
  transactionDate: "Transaction Date",
  interestAmount: "Interest Amount",
  paymentTypes: "Payment Types",
  selectStaff: "Select Staff",
  balanceForInterestCalculation: "Balance For Interest Calculation",

  showPaymentDetails: "Show Payment Details",
  note: "Note",
  chequeNumber: "Cheque Number",
  routingCode: "Routing Code",
  receiptNumber: "Recipient Number",
  toLoanOfficer: "To Loan Officer",
  assignmentDate: "Assignment Date",
  unassignmentDate: "Un-Assignment Date",
  interest: "Interest",
  feeAmount: "Fee Amount",
  penaltyAmount: "Penalty Amount",
  interestWaivedOn: "Interest Waived On",
  liabilityCategory: "Liability Category",
  limitInformation: "Limit Information",
  limitEndDate: "Limit End Date",
  amountInformation: "Amount Information",
  utilizationInformation: "Utilization Information",
  utilizedLimit: "Utilized Limit",
  revolvingLine: "Revolving Line",
  retrieveCollateral: "Track Collateral",
  newLimitMsg: "Limit was successfully created",
  updateKycMsg: "KYC Info was successfully updated",
  unAuthorisedLimit: "Unauthorised Limit",
  digitsAfterDecimal: "Digits After Decimal",
  inMultiplesOf: "In Multiples Of",
  inMultiplesOfType: "in Multiples Of Type",
  liabilityId: "Liability Id",
  limitLineNo: "LimitLine Number",
  reOpen: "Re-Open",
  updateLimitMsg: "Limit was successfully updated",
  chargeTime: "Charge Time",
  withdrawalFee: "Withdrawal Fee",
  lastActiveTransactionDate: "Last Active Transaction Date",
  annualFee: "Annual Fee",
  maxOverdraftLimit: "Max Overdraft Limit",
  interestRecalculationDate: "Interest Recalculation Date",
  totalWithdrawalsFees: "Total Withdrawals",
  totalAnnualFees: "Total Annual Fees",
  interestPosted: "Interest Posted",
  lienBlockedAmount: "Lien(Blocked Amount)",
  earnedInterestNotPosted: "Earned Interest Not Posted",
  customerStatusMsg: "Customer Status was successfully updated",
  date: "Date",
  delete: "Delete",
  deleted: "Deleted",
  manageFixedDepositAccount: "Manage Fixed Deposit Account",
  accountNumber: "Account Number",
  productName: "Product Name",
  shortName: "Short Name",
  lastActive: "   Last Active",
  balance: "Balance",
  newFixedDepositAccount: "New Fixed Deposit Account",
  fixedDepositAccountList: "Fixed Deposit Account List",
  newFixedDepositAccountMsg: "Fixed Deposit Account was successfully created",
  fieldOfficer: "Field Officer",
  usDollar: "US Dollar",
  defaultDepsoitAmount: "Default Deposit Amount",
  minimumDepositAmount: "Minimum Deposit Amount",
  maximumDepositAmount: "Maximum Deposit Amount",
  depositPeriod: "Deposit Period",
  depositPeriodType: "Deposit Period Type",
  depositPeriodFrequency: "Deposit Period Frequency",
  minimumDepositTerm: "Minimum Deposit Term",
  minimumDepositTermTypes: "Minimum Deposit Term Type",
  thereAferTerms: "And Thereafter, In Multiples Of",
  maximumDepositTerm: "Maximum Deposit Term",
  maximumDepositTermType: "Maximum Deposit Term Type",
  preMatureClosure: "Apply Penal Interest for Pre-mature Closure?",
  transferInterestToLinkedSavingsAccount: "Transfer Interest to Linked Account",
  maturityInstruction: "Maturity Instruction",
  transferToSavingsAccount: "Transfer To Savings Account",
  transferToAccount: "Transfer To Account",
  validfromDate: "Valid Start Date",
  isWithholdTax: "Is Withhold Tax Applicable",
  withholdingTaxRate: "Withholding Tax Rate",
  withholdingTaxAmount: "Withholding Tax Amount",
  endDate: "End Date",
  isPrimaryGroupingByAmount: "Is Primary Grouping By Amount",
  add: "Add",
  detailFixedDepositAccount: " Fixed Deposit Account Detail ",
  savingsDetails: "Savings Details",
  depositDetails: "Deposit Details",
  daily: "Daily",
  averageDailyBalance: "Average Daily Balance",
  unAssigned: "Unassigned",
  notProvided: "Not Provided",
  editFixedDepositAccount: "Edit Fixed Deposit Account",
  editFixedDepositAccDetails: "Edit Fixed Deposit Account Details",
  datePastDue: "Date Past Due",
  lastRate: "Last Rate Change Date",
  interestEarned: "Interest Earned",
  finInterest: "FIN Interest Earned",
  ytdInterest: "YTD Interest Earned",
  contractReference: "Contract Reference",
  dsgInsured: "DSG Insured Amount",
  dsgUninsured: "DSG Uninsured Amount",
  hedgingPortf: "Hedging Portfolio Ref",
  daysPastDue: "Days Past Due",
  nonPerforming: "Non Performing",
  stressWithdrawal: "Stress Withdrawal",
  transactionalAcc: "Transactional Account",
  suspectedLaundering: "Suspected Money Laundering",
  fraud: "Fraud",
  legallyDisputed: "Legally Disputed",
  undocumentedAcc: "Undocumented Account",
  repoReference: "Repo Reference Cash Leg",
  universalSourceSys: "Universal Source System",
  structuredDepositAcc: "Structured Deposit Account",
  operationalDeposit: "Operational Deposit",
  universalBranchId: "Universal Branch Id",
  accountStatusCode: "Account Status Code",
  transferableEligbleDep: "Transferable Eligble Deposit",
  iban: "IBAN",
  swiftCode: "Swift Code",
  wireRoutingNo: "Wire Routing No",
  upic: "UPIC",
  accountHolderInd: "Account Holder Indication",
  extensionCode: "Extension Code",
  sortCode: " Sort Code",
  extensionAccNo: "Extension Account No",
  achRoutingNo: "Ach Routing No",
  bic: "BIC",
  dormantDate: "Dormant Date",
  debitInterestRate: "Debit Interest Rate",
  ifrsPortfolioType: "IFRS9 Portfolio Type",
  dateOfPerformance: "Date of Performance Status Change",
  symmetricalInflow: "Symmetrical Inflow Rate",
  universalHqla: "Universal HQLA Indicator",
  accountBalanceLocalCurrency: "Account Balance Local Currency",
  typeOfBusinessActivity: "Type of Business Activity",
  typeOfClientAccForCass: "Type of Client Account For CASS",
  linkedToPeriodicRfRate: "Linked to Periodic Reference Rate",
  universalImpairmentStatus: "Universal Impairment Status",
  facilityReference: "Facility Reference",
  portfolioType: "Portfolio Type",
  rateSpread: "Rate Spread",
  performingStatus: "Performing Status",
  lastIntrstCapDate: "Last Interest Capitalisation Date",
  clientMoneyPlaced: "Client Money Placed",
  instWhereTheClMnPlcd: "Institution where the Client Money is placed",
  clientAccAckLetter: "Client Account Acknowledgment Letter",
  universalAccumImpAmnt: "Universal Accumulated Impairment Amount",
  transcAccFlagBranchRt: "Transactional Account Flag (Branch Return)",
  universalGlMarker: "Universal GL Marker",
  overdrawnLimit: "Overdrawn Limit",
  purposeType: "Purpose Type",
  ldStartDate: "LD Start Date",
  ldMaturityDate: "LD Maturity Date",
  repaymentType: "Repayment Type",
  remainingTerm: "Remaining Term",
  interestMargin: "Interest Margin",
  rollOverIndicator: "Rollover Indicator",
  formalArrangmentSf: "Formal Arrangement For Shortfall",
  lastCstDrivenTransaction: "Last Customer Driven Transaction",
  irregularSchedule: "Irregular Schedule",
  nextRollOverDate: "Next Rollover Date",
  lastRollOverDate: "Last Rollover Date",
  originalTerm: "Original Term",
  assessmentType: "Assessment Type",
  loanPurchased: "Loan Purchased",
  additionalStricter: "Additional Stricter Prudential Requirements Flag",
  encumberedAssetFlag: "Encumbered Asset Flag",
  coveredByDgs: "Covered by DGS",
  encumberedAmount: "Encumbered Amount",
  paymentsSuspended: "Payments Suspended",
  termExtension: "Term Extension",
  nonPerfBfForBearance: "Non-performing before Forbearance Measures",
  dateOfFormalArrang: "Date of Formal Arrangement",
  dateOfTermExtension: "Date of Term Extension",
  dateOfOtherForBearance: "Date of Other Forbearance",
  loanToValue: "LTV (Loan to Value)",
  coverPoolID: "Cover Pool ID",
  impairmentStartDate: "Impairment Start Date",
  temporarySwitchToInt: "Temporary Switch To Interest-only",
  reducedPayment: "ReducedPayment",
  otherForBearance: "Other Forbearance",
  centralBankEligibleFlag: "Central Bank Eligible Flag",
  dateOfInterestOnlySwitch: "Date of Interest-only Switch",
  dateLitigationAction: "Date Litigation Action Started",
  universalIntOnMaturity: "Universal Interest On Maturity",
  nettingFlag: "Netting Flag",
  interestReversionDate: "Interest Reversion Date",
  loanCollateralPoolRf: "Loan Collateral Pool Reference",
  accountDescription: "Account Description",
  localCurrencyCode: "Local Currency Code",
  applicationReference: "Application Reference",
  dateOfReducedPayment: "Date of reduced payment",
  accBalanceLocalCurrency: "Account Balance Local Currency",
  gbp: "GBP",
  staff: "Staff",
  relationshipManager: "Relationship Manager",
  customerList: "Customer List",
  show: "Show",
  entries: "Entries",
  searchByName: "Search by Name...",
  download: "Download",
  remove: "Remove",
  client: "Client #",
  addCustomer: "Add Customer",
  edit: "Edit",
  approve: "Approve",
  dissaprove: "Dissaprove",
  backToTop: "Back to Top",
  home: "Home",
  manageServiceProviders: "Manage Service Providers",
  nameAndContact: " Name and Contact",
  agentType: "Agent Type",
  legalForm: "Legal Form",
  individual: "Individual",
  company: "Company",
  title: "Title",
  mr: "Mr.",
  ms: "Ms.",
  mrs: "Mrs.",
  pleaseSelectAValue: "Please Select a Value",
  idType: "Identification Type",
  idNumber: "Identification No.",
  gender: "Gender",
  male: "Male",
  female: "Female",
  homeAddress: " Home Address",
  address1: "Address 1",
  address2: "Address 2",
  address3: "Address 3",
  workAddress: " Work Address",
  workEmail: "Work Email",
  otherEmail: "Other Email",
  homePhone: "Home Phone",
  workPhone: "Work Phone",
  mobilePhone: "Phone",
  kycLevel: "KYC Level",
  customerClass: "Customer Class",
  submit: "Submit",
  cancel: "Cancel",
  southAfrica: "South Africa",
  nigeria: "Nigeria",
  kenya: "Kenya",
  customButton: "CustomButton",
  viewCustomer: "View Customer",
  authorised: "Authorised",
  editCustomers: "Edit Customers",
  back: "Back",
  number: "+27 60 971 9460",
  kycGroup: "KYC Group",
  kycStatus: "KYC Status",
  investment: "Investment",
  fixedAsset: "Fixed Asset",
  currentAssets: "Current Assets",
  cash: "Cash",
  inventory: "Inventory",
  accountsReceivable: "Accounts Receivable",
  totalAssets: "Total Assets",
  assetPosition: "Asset Position",
  totalLiabilities: "Total Liabilities",
  liabilityPosition: "Liability Position",
  customerID: "Customer ID",
  liability: "Liability",
  foreName3: "ForeName3",
  noData: "No Data",
  previousName: "Previous Name",
  counterPartyParent: "Counterparty Parent",
  deviceID: "Device ID",
  nationalID: "National ID",
  relationShipInfo: "Relationship Info",
  customerDirectorIndicator: "Customer Director Indicator",
  establishedRelationShipFlag: "Established Relationship Flag",
  businessInfo: "  Business Info",
  bankOfEnglandIndCode: "Bank of England Industry Code",
  naceCode: "NACE Code",
  retailFlag: "Retail Flag",
  smeFlag: "SME Flag",
  annualTurnover: "Annual Turnover",
  centralBankCode: "Central Bank Code",
  interCompanyFlag: "Intercompany Flag",
  shortAndLongTermRating: "Short / Long Term Rating",
  centralGovmntRatingInd: "Central Government Rating Indicator",
  nationalCode: "National Code",
  instWhereClientMoneyIsPaid: "Institution Where Client Money Is Placed",
  frequencyInternal: "Frequency Internal Client Reconciliation",
  frequnecyExternal: "Frequency External Client Reconciliation",
  treasuryDealerLines: "Treasury Dealers Lines",
  dayTimePhoneNo: "Daytime Phone No ",
  eveningPhoneNo: "Evening Phone No",
  requiresBraille: "Requires Braille",
  contactEmail: "Contact Email",
  contactPhoneNo: "Contact Phone No.",
  taxInfo: " Tax Info",
  taxGroup: " Tax Group",
  nonPerformingFlag: "Non Performing Flag ",
  taxID: "Tax ID",
  taxIDNumber: "Tax Identification Number (TIN)",
  addedTaxJuri: " Added Tax Jurisdiction",
  politicallyExposed: "Politically Exposed",
  deceased: "Deceased",
  dgsEligible: "DGS Eligible ",
  dgsEligibleReason: "DGS Eligible Reason",
  limit: "Limit",
  utilisedLimit: "Utilised Limit",
  unUsedLimit: "Un-used Limit",
  globalLimit: "Global Limit",
  accountLimit: "Account Limit",
  cardLimit: "Card Limit",
  liabilityB: "Liability",
  liabilityID: "Liability ID",
  loanAndAdvances: "Loan & Advances",
  viewCollateral: "  View Collateral",
  secured: "Secured",
  unSecured: "Unsecured",
  overdraft: "Overdraft",
  guarantee: "Guarantee",
  bnpl: "BNPL",
  addSignatory: "Add Signatory",
  assignPrivileges: "Assign Privileges",
  assignLimits: "Assign Limits",
  customerAdded: "This Customer is already added!",
  successFullyDeleted: "Successfully deleted!",
  customerIdentification: "Customer Identification",
  searchByCustomerID: "Search by Customer ID",
  fullName: "Full Name",
  addedSignatory: "Added Signatory",
  passPortNo: "Passport No.",
  selectSignatory: "Select Signatory",
  availablePrivileges: "Available Privileges",
  assign: "Assign",
  assignedPrivileges: "Assigned Privileges",
  save: "Save",
  transactionLimit: "Transaction Limit",
  enterAmount: "Enter amount",
  usd: "USD",
  approvalLimit: "Approval Limit",
  loanBalance: " Loan Balance",
  actions: "Actions",
  casaAccount: "CASA Account",
  loanAccount: "Loan Account",
  viewClosedLoans: " View closed loans",
  cardInfo: " Card",
  walletInfo: " Wallet Account",
  investmentInfo: " Investment Info",
  addAddress: " Add Address",
  info: "INFO",
  disable: "Disable",
  enable: "Enable",
  disableSuccessMsg: "Address Disabled successfully",
  enableSuccessMsg: "Address Enabled successfully",
  addressID: "Address ID",
  addressLine1: "Address Line 1",
  addressLine2: "Address Line 2",
  addressLine3: "Address Line 3",
  city: "City",
  stateOrProvince: "State / Province",
  isActive: "is Active?",
  latitude: "Latitude",
  country: "Country",
  updatedDate: "Updated Date",
  detailsForm: "Details form",
  termsForm: "Terms form",
  settingsForm: "Settings Form",
  interestRateChartForm: "InterestRateChart Form",
  chargesForm: "Charges Form",
  review: "Review",
  addLoanChargeMsg: "Loan Charge was successfully added",
  loanTermFrequency: "Loan Term Frequency",
  paymentInformation: "Payment Information",
  depositInformation: "Deposit Information",
  createStandingInstruction: "Create Standing Instruction",
  onArrearsAging: "On Arrears Aging",
  postInterestAasOn: "Post Interest As on",
  deposit: "Deposit",
  withdraw: "Withdraw",
  calculateinterest: "Calculate Interest",
  hold: "Hold",
  holdAccount: "Hold Account",
  assignStaff: "Assign Staff",
  postInterest: "Post Interest",
  addCharge: "Add Charge",
  manageAccount: "Manage Account",
  passfort: "Passfort",
  transferFunds: "Transfer Funds",
  depositMoney: "Deposit Money to Saving Account",
  bank: "Bank",
  interestInformation: "Interest Information",
  selectedCharge: "Selected Charge",
  selectedCharges: "Selected Charges",
  overdueCharge: "Overdue Charge",
  overdueCharges: "Overdue Charges",
  selectedCollateral: "Selected Collateral",
  selectedCollaterals: "Selected Collaterals",
  disburseAmount: "Disburse Amount",
  approvedAmount: "Approved Amount",
  proposedAmount: "Proposed Amount",
  disbursementDate: "Disbursement Date",
  accountInformation: "Account Information",
  transactionType: "Transaction Type",
  paymentDetail: "Payment Detail",
  bankNumber: "Bank Number",
  bankName: "Bank Name",
  undoTransactionMsg: "Transaction successfully reversed",
  editTransactionMsg: "Transaction is successfully updated",
  withdrawMoney: "Withdraw Money From Saving Account",
  accountInfo: "Account Information",
  financialInfo: "Financial Information",
  interestRate: "Interest Rate",
  selectedInterestRate: "Selected Interest Rate",
  selectedInterestRates: "Selected Interest Rates",
  closeSavings: "Close Savings Account",
  closedOn: "Closed On",
  withdrawBalance: "Withdraw Balance",
  viewJournalEntries: "View Journal Entries",
  generateCertificate: "Generate Certificate",
  regenerateCertificate: "Regenerate Certificate",
  filter: "Filter",
  dateRange: "Date Range",
  parameters: "Parameters",
  createdBy: "Created By",
  createdOn: "Created On",
  entryId: "Entry ID",
  office: "Branch",
  debit: "Debit",
  paymentTypeId: "Payment Type ID",
  chequeNo: "Cheque No",
  receiptNo: "Receipt No",
  bankNo: "Bank No",
  isInterestPostingRequiredOnClosureDate:
    "Is Interest Posting required on Closure Date?",
  closedDate: "Closed Date",
  bioInfo: "Bio Info",
  statusInfo: " Status Info",
  transactionId: "Transaction ID",
  lienTransaction: "Lien Transaction",
  search: "Search",
  detailJournalEntry: "Journal Entry Detail",
  journalEntries: "Journal Entries",
  searchJournalEntries: "Search Journal Entries",
  searchParams: "Search Parameter",
  account: "Account",
  credit: "Credit",
  manageJournalEntries: "Manage Journal Entries",
  paymentDueAt: "Payment Due At",
  paymentDueAsOf: "Payment Due As Of",
  calculationType: "Calculation Type",
  paymentDate: "Payment Date",
  interestRateInfo: "Interest Rate Information",
  collateralInfo: "Collateral Information",
  repaymentInformation: "Repayment Information",
  expectedDisbursementDate: "Expected Disbursement Date",
  approvedOn: "Approved On",
  approveLoanAcc: "Approve Loan Account",
  rejectedOn: "Rejected On",
  rejectLoanAcc: "Reject Loan Account",
  rejectLoanAccMsg: "Loan Account Successfully Rejected",
  approveLoanAccMsg: "Loan Account Successfully Approved",
  assignLoanOfficerMsg: "Loan Offcier Successfully Assigned",
  LoanPrepaymentMsg: "Loan Prepayment Successful",
  undoDisbursalMsg: "Loan Disbursal Successfully Reversed",
  undoApprovalMsg: "Loan Approval Successfully Reversed",
  loanDisbursal: "Disburse Loan Account",
  disbursedOnDate: "Disbursed On Date",
  loanDisbursementMsg: "Loan Disbursement Successful",
  loanRepaymentMsg: "Loan Repayment Successful",
  loanRepayment: "Loan Repayment",
  waiveInterestMsg: "Waive Interest Successful",
  writeOffMsg: "Write Off Successful",
  closeAsRescheduledMsg: "Loan Account Successfully Closed",
  collateralType: "Collateral Type",
  addLoanCollateral: "Add Loan Collateral",
  addCollateralMsg: "Loan Collateral Successfully Added",
  foreClosureMsg: "Foreclosure Successful",
  totalWithdrawalFees: "Total Withdrawal Fees",
  modifyApplicationMsg: "Loan Application Successfully Modified",
  modifyApplication: "Edit Loan Application",
  withdrawnOn: "Withdrawn On",
  withdrawLoanAccount: "Withdraw Loan Account",
  withdrawLoanAccountMsg: "Loan Account Successfully Withdrawn",
  chargeInfo: "Charge Information",
  interestRecalculation: "Interest Recalculation",
  frequencyForCompounding: "Frequency For Compounding",
  repaymentInfo: "Repayment Info",
  dueOn: "Due On",
  noDuplicateCharges: "No Duplicate Charge Allowed!",

  //LOAN ACCOUNT
  fees: "Fees",
  rescheduleFromInstallment: "Reschedule From Installment On",
  reasonForRescheduling: "Reason For Rescheduling",
  submittedDate: "Submitted Date",
  changeRepaymentDate: "Change Repayment Date",
  installmentRescheduledTo: "Installment Rescheduled To",
  introduceGracePeriod: " Introduce Mid-term Grace Periods ",
  extendRepaymentPeriod: " Extend Repayment Period",
  adjustInterestRates: "Adjust Interest Rates For Remainder of Loan",
  changeEMI: " Change EMI",
  changeFixedPrincipal: "Change Fixed Principal % per Installment",
  principalGracePeriods: " Principal Grace Periods",
  interestGracePeriods: " Interest Grace Periods",
  noOfNewRepayments: "Number of New Repayments",
  newInterestRates: "New Interest Rates",
  EMIChange: "EMI Change End Date",
  newEMI: "New EMI",
  newFixedPrincipal: "New Fixed Principal % per Instalment ",
  rescheduleMsg: "Loan Reschedule Successful",
  comment: "Comment",
  addLoanTranche: "Add Loan Tranche",
  fixedPrincipal: "Fixed Principal % Per Instalment",
  totalOutstanding: "Total Outstanding",
  totalLate: "Total Late",
  totalInAdvance: "Total In Advance",
  totalInterest: "Total Interest",
  totalFees: "Total Fees",
  totalPenalties: "Total Penalties",
  totalDue: "Total Due",
  totalPaid: "Total Paid",
  totalPricipalDue: "Total Principal Due",
  principalpaymentdetail: "Principal Payment",
  interestspayment: "Interest Payment",
  createChargeLoanTest: "Create Charge Loan Test",
  hideAccruals: "Hide Accruals",
  viewRepaymentSchedule: " View Repayment Schedule",
  hideRepaymentSchedule: " Hide Repayment Schedule",
  rejectRescheduleMsg: "Loan Reschedule Successfully Rejected",
  approveRescheduleMsg: "Loan Reschedule Successfully Approved",
  maximumAllowedOutstandingBalance: "Maximum Allowed Outstanding Balance",
  installmentAmountVariations: "Installation Amount Variations",
  nominalInterestRateFrequency: "Nominal Interest Rate Frequency",

  //END OF LOAN ACCOUNT

  //CURRENT ACCOUNT
  toCurrentOfficer: "To Current Officer",
  ChargeInformationSetup: "Charge Information Setup",
  currentOfficer: "Current Officer",
  undoApprovalCurrentAcc: "Undo Approval Current Account",
  newCurrentAccount: "New Current Account",
  detailCurrentAccount: "Current Account Detail",
  editCurrentAccount: "Edit Current Account",
  newCurrentAccountMsg: "Current Account was successfully created",
  editCurrentAccountMsg: "Current Account was successfully edited",
  deleteCurrentAccountMsg: "Current Account was successfully deleted",
  manageCurrentAccount: "Manage Current Account",
  AccountSuccefullyApproved: "Account Successfully Approved",
  TransactionSuccessfullyReversed: "Transaction Successfully Reversed",
  assignCurrentOfficer: "Assign Current Account Officer",
  rejectedOnDate: "Rejected On",
  rejectCurrentAccount: "Reject Current Account",
  withdrawCurrentAccount: "Withdraw Current Account",
  AccountSuccessfullyWithdrawn: "Account Successfully Withdrawn",
  savingsLinkage: "Savings Linkage",
  UnassignCurrentOfficer: "Unassign Current Account Officer",
  OfficerSuccefullyUnassigned: "Officer Successfully Unassigned",
  addChargesCurrentAcc: "Add Current Charges",
  closeCurrentAcc: "Close Current Account",
  updateCurrentAccountMsg:
    "Current Account Application was successfully modified",
  maxOverdraftLimit: "Max Overdraft Amount should not exceed",
  minOverdraftLimit: "Min Overdraft Amount should not be equal to",
  noOverdraftLimit: "No active Overdraft Limit found for this client",
  accountSuccefullyWithdrawn:
    "Current Account Application was succefully withdrawn",
  currentAccWithdrawnMsg:
    "Current Account Application was successfully withdrawn",
  currencyCloud: "Currency Cloud",
  fscs: "FSCS",
  clearBank: "ClearBank",
  bicOrRoutingCode: "BIC or Routing Code",
  accountNumberType: "Account Number Type",
  routingCodeType: "Routing Code Type",
  accountNumberAch: "Account Number ACH",
  bicOrRoutingCodeAch: "BIC or Routing Code ACH",
  accountNumberTypeAch: "Account Number Type ACH",
  routingCodeTypeAch: "Routing Code Type ACH",
  multicurrencyAccountPool: "Multicurrency Account Pool",
  statusCode: "Status Code",
  exclusionIdentifier: "Exclusion Identifier",
  accountId: "Account ID",
  MandateDetails: "Mandate Details",
  assignedDepositorUser: "Assigned Depositor User",
  depositIban: "Deposit IBAN",
  editFscsData: "Edit FSCS Data",
  fscsEligible: "FSCS Eligible",
  successfullCalcInterestCurrentAcc:
    "Current Account Interest was succesfully calculated",
  successfullPostInterestCurrentAcc:
    "Current Account Interest was succesfully posted",
  viewManagedAccountDetails: "View Managed Account Details",
  editManageCurrentAcc: "Edit Manage Current Account",
  activateCurrentAcc: "Activate Current Account",
  addChargesCurrentAccMsg: "Current Account Charge was succesfully added",
  approveCurrentAcc: "Approve Current Account",
  assignCurrentOfficerMsg: "Officer was succesfully assigned",
  depositCurrentAccMsg: "Deposit Money to Current Account",
  postInterestAasOnCurrentAccMsg:
    "Current Account Interest was successfully posted",
  rejectCurrentAccountMsg: "Current Account was succesfully rejected",
  transferFundsCurrentAccMsg: "Current Account was updated",
  undoApprovalCurrentAccMsg: "Current Account was successfully undone",
  withdrawCurrentAccountMsg: "Withdraw Money From Current Account",
  postInterestCurrentAccMsg: "Current Account Interest was succesfully posted",
  calculateInterestCurrentAccMsg:
    "Current Account Interest was succesfully calculated",

  // END OF CURRENT ACCOUNT

  //SAVINGS ACCOUNT
  savingsOfficer: "Savings Officer",
  undoApprovalSavingsAcc: "Undo Approval Savings Account",
  manageSavingsAccount: "Manage Savings Account",
  newSavingsAccount: "New Savings Account",
  detailSavingsAccount: "Savings Account Detail",
  editSavingsAccount: "Edit Savings Account",
  savingsAccountsSetup: "Savings Account Setup",
  currentAccountsSetup: "Savings Account Setup",
  newSavingsAccountMsg: "Savings Account was successfully created",
  editSavingsAccountMsg: "Savings Account was successfully edited",
  deleteSavingsAccountMsg: "Savings Account was successfully deleted",
  transactionSuccesfullyProcessed: "Transaction successfully processed",
  accountSuccefullyApproved: "Account Successfully Approved",
  accountSuccefullyActivated: "Account Successfully Activated",
  transactionDetail: "Transaction Detail",
  transactionSuccessfullyReversed: "Transaction successfully reversed",
  assignSavingsOfficer: "Assign Savings Officer",
  selectOfficer: "Select Officer",
  unassignSavingsOfficer: "Unassign Savings Officer",
  rejectSavingsAccount: "Reject Savings Account",
  rejectSavingsAccountMsg: "Savings Account was successfully rejected",
  undoSavingsAccountMsg: "Savings Account was successfully undone",
  updateSavingsAccountMsg: "Savings Account was updated",
  collectedOn: "Collected On",
  reasons: "Reasons",
  withdrawSavingsAccount: "Withdraw Savings Account",
  closeSavingsAcc: "Close Savings Account",
  depositAmount: "Deposit Amount",
  depositStartDate: "Deposit Start date ",
  depositFrequency: "Deposit Frequency",
  depositFrequencyType: "Deposit Frequency Type",

  // END OF SAVINGS ACCOUNT

  // TERM DEPOSIT ACCOUNT
  newLoanAccount: "New Loan Account",
  newDepositAccount: "New Deposit Account",
  accountSetup: "Account Setup",
  details: "Details",
  assets: "Assets",
  terms: "Terms",
  interestRateChart: "Interest Rate Chart",
  settings: "Settings",
  preview: "Preview",
  liabilities: "Liabilities",
  expenses: "Expenses",
  income: "Income",

  // FIXED DEPOSIT ACCOUNT
  withholdTaxGroup: "Withhold Tax Group",
  withholdTaxAmount: "Withhold Tax Amount",
  interestDetails: "Interest Details",
  fixedDepositChargeMsg: "Fixed Deposit Charge Successfully Added",
  addFixedDepositCharge: "Add Fixed Deposit Charge",
  approveFixedDepositAccMsg: "Fixed Deposit Application Successfully Approved",
  approveFixedDepositAcc: "Approve Fixed Deposit Account",
  lastRateChangeDate: "Last Rate Change Date",
  YTDInterestEarned: "YTD Interest Earned",
  FINInterestEarned: "FIN Interest Earned",
  DSGInsuredAmount: "DSG Insured Amount",
  DSGUninsuredAmount: "DSG Uninsured Amount",
  hedgingPortfolioRef: " Hedging Portfolio Ref",
  repoReferenceCashLeg: "Repo Reference Cash Leg",
  universalSourceSystem: "Universal Source System",
  accountHolderIndicator: "Account Holder Indicator",
  IFRS9PortfolioType: "IFRS9 Portfolio Type",
  dateofPerformanceStatusChange: " Date of Performance Status Change",
  symmetricalInflowRate: "Symmetrical Inflow Rate",
  lastInterestCapitalisationDate: "Last Interest Capitalisation Date",
  universalHQLAIndicator: " Universal HQLA Indicator",
  structuredDepositAccount: "Structured Deposit Account",
  typeofBusinessActivity: "Type of Business Activity",
  institutionWhere: " Institution where is the Client Money placed?",
  institutionCode: " Institution Code",
  typeofClientAccount: " Type of Client Account for CASS",
  clientClientAccountAcknowledgement:
    "ClientClient Account Acknowledgement Letter",
  linkedToPeriodic: "Linked to Periodic Reference Rate",
  universalAccumulatedImpairment: "Universal Accumulated Impairment Amount",
  universalGLMarker: "Universal GL Marker",
  beneficiary: "Beneficiary",
  LDStartDate: "LD Start Date",
  nextRolloverDate: "Next Rollover Date",
  lastRolloverDate: "Last Rollover date",
  LDMaturityDate: "LD Maturity Date",
  repaymentType: "Repayment Type",
  rolloverIndicator: "Rollover Indicator",
  forbearanceStatus: "Forbearance Status",
  assessmentType: "Assessment Type",
  additionalStricterPrudentialRequirements:
    "Additional Stricter Prudential Requirements Flag",
  encumberedAssetFlag: "Encumbered Asset Flag",
  additionalStricterPrudentialRequirements:
    "Additional Stricter Prudential Requirements Flag",
  coveredByDGS: "Covered by DGS",
  accumulatedImpairmentAmount: "Accumulated Impairment Amount",
  formalArrangement: "Formal Arrangement For Shortfall",
  dateOfFormalArrangement: "Date of Formal Arrangement",
  temporarySwitch: "Temporary Switch To Interest-only",
  dateOfInterestOnly: "Date of Interest-only Switch",
  datePaymentsSuspended: "Date Payments Suspended",
  otherForbearance: "Other Forbearance",
  transactionalAccount: "Transactional Account",
  dateOfOtherForbearance: "Date of other Forbearance",
  nonPerformingBeforeForbearance: "Non-performing Before Forbearance Measures",
  LTV: "LTV (Loan to Value)",
  universalInterestOnMaturity: "Universal Interest On Maturity",
  centralBankEligible: "Central Bank Eligible Flag",
  loanCollateralPool: "Loan Collateral Pool Reference",
  transferableEligibleDeposit: "Transferable Eligible Deposit",
  manageFixedDepositAccountDetails: "Manage Fixed Deposit Account Details",
  repoReferenceCashleg: "Repo Reference Cashleg",
  undoApprovalFixedDepositAcc: "Undo Approval of Fixed Deposit Application",
  undoApprovalFixedDepositAccMsg:
    "Fixed Deposit Application Successfully Unapproved",
  rejectFixedDepositAccount: "Reject Fixed Deposit Account",
  fixedDepositUpdateMsg: "Fixed Deposit Account was Updated",
  rejectFixedDepositMsg: "Fixed Deposit Account was succesfully rejected",
  prematureCloseFixedDeposit: "Premature Closure of Fixed Deposit Account",
  prematureCloseFixedDepositMsg:
    "Fixed Deposit Account was succesfully closed prematurely",
  closeFixedDeposit: "Closure of Fixed Deposit Account",
  closeFixedDepositMsg: "Fixed Deposit Account was succesfully closed",
  premClosedDate: "Pre Mature Close Date",
  action: "Action",
  transferDescription: "Transfer Description",
  transferToSavings: "Transfer to Savings",
  activationCharge: "Activation Charge",
  fixedDepositAccWithdrawnMsg:
    "Fixed Deposit Account Application was successfully withdrawn",
  withdrawFixedDepositApp: "Withdraw Fixed Deposit application",
  manageRecurringDepositAccount: "Manage Recurring Deposit Account",
  recurringDepositAccountList: "Recurring Deposit Account List",
  detailRecurringDepositAccount: " Recurring Deposit Account Detail ",
  activateFixedDeposiAcc: "Activate Fixed Deposit account",
  fixedDepositAccSetUp: "Fixed Deposit Account Setup",
  summary: "Summary",

  //RECURRING DEPOSIT
  approveRecurringDepositAcc:
    "Recurring Deposit Account was succesfully approved",
  undoApprovalRecurringDepositAccMsg:
    "Recurrent Deposit Account  was successfully disapproved",
  undoApprovalRecurringDepositAcc:
    "Undo Approval of Recurring Deposit application",
  newRecurringDepositAccount: "New Recurring Deposit Account",
  newRecurringDepositAccountMsg:
    "Recurring Deposit Account was successfully created",
  recurringDepositAmount: "Recurring Deposit Amount",
  RejectRecurringDepositAcc: "Reject Recurring Deposit Application",
  isMandatoryDeposit: " Is Deposit Mandatory?",
  addChargesRecurringDepositAcc: "Add Recurring Deposit Charges",
  allowWithdrawals: "Allow Withdrawals",
  withdrawRecurringDepositMsg: "Recurring Deposit Withdrawal was successful",
  activateRecurringDeposiAcc: "Activate Recurring Deposit Account",
  activateRecurringDepositAccMsg:
    "Recurring Deposit Account was successfully activated",
  adjustAdvancePayments: "Adjust Advance Payments toward future Installments",
  depositFrequencySameAsGroup: "Deposit Frequency Same as Group/Center Meeting",
  prematureCloseRecurringDeposit:
    "Premature Closure of Recurring Deposit Account",
  prematureCloseRecurringDepositMsg:
    "Recurring Deposit Account was succesfully closed prematurely",
  depositRecurringDepositAcc: "Deposit Money to Recurring Deposit Account",
  balanceRequiredForInterestCalculation:
    "Balance Required For Interest Calculation",
  UndoApprovalRecurringDepositAcc:
    "Undo Approval of Recurring Deposit Application",
  withdrawFromRecurringDepositAcc:
    "Withdraw Money From Recurring Deposit Account",
  withdrawRecurringDepositApplication: "Withdraw Recurring Deposit application",
  recurringDepositAccWithdrawnMsg:
    "Recurring Deposit Account Application was successfully withdrawn",
  deleteRecurringDepositAccountMsg:
    "Recurring Deposit Account was successfully deleted",
  editRecurringDepositApplication: "Edit Recurring Deposit Application",
  recurringDepositUpdateMsg: "Recurring Deposit Account was Updated",
  previous: "Previous",
  next: "Next",
  lockInPeriodType: "Lock-In Period Type",
  editMemoMsg: "Memo is Successfully Edited",
  newMemoMsg: "Memo is Successfully Created",
  deleteMemoMsg: "Memo is Successfully Deleted",
  manageMoneyMarketAccount: "Manage Money Market Contract",
  NewMoneyMarketAccount: "New Money Market Contract",
  manageAccountDetails: "Manage Account Details",
  newMoneyMarketAccount: "New Money Market Contract",
  productType: "Product Type",
  productInfo: "Product Information",
  numberOfRepayments: "Number Of Repayments",
  interestChargedFrom: "Interest Charged From",
  nominalInterestRate: "Nominal InterestRate",
  amortization: "Amortization",
  contractSetup: "Contract Setup",

  // STANDING INSTRUCTION
  manageStandingInstructons: "Manage Standing Instructions",
  newStandingInstruction: "New Standing Instruction",
  editStandingInstructons: "Edit Standing Instructions",

  // COUNTER PARTY
  maxLimitAmountLcy: "Maximum Limit Amount (LCY)",
  currentLimitUtilizationLcy: "Current Limit Utilization (LCY)",
  placementDealAccountLcy: "External Deal Account Number",
  // placementDealAccountLcy: "Placement Deal Account (LCY)",
  createdBy: "Created By",
  createdDate: " Created Date",
  lastModifiedBy: "Last Modified By",
  lastModifiedDate: "Last Modified Date",
  counterPartyID: "Counter Party ID",
  counterPartyName: "Counter Party Name",
  counterPartyType: "Counter Party Type",
  counterPartyStatus: "Counter Party Status",
  contactInfo: "Contact Info",
  institutionInfo: "Institution Info",
  creditRiskRating: "Credit Risk Rating",
  newCounterPartyMsg: "Counter Party added Successfully",
  manageLoanApproval: "Manage Loan Approval",
  updateCounterPartyMsg: "Counter Party Updated Successfully",
  bondsInfo: "Bonds Deal",
  treasuryInfo: "Treasury Bills Deal",
  interbankInfo: "Interbank Deals",
  customerListing: "Customer Listing",
  serviceProviderListing: "Service Provider Listing",
  createServiceProvider: "Create Service Provider...",
  updateServiceProvider: "Update Service Provider...",
  editServiceProvider: "Edit Service Provider",
  tradingName: "Trading Name",
  taxIdentificationNumber: "Tax Identification Number(TIN)",
  businessDecription: "Business Description",
  natureOfBusiness: "Nature of Business",
  customerType: "Customer Type",
  activateServiceProviderMsg: "Service Provider was successfully activated",
};

/*!*******************************************************************************!
    !*** CUSTOMER STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const staticConfig = {
  manageBreadcrumbItems: [{ title: labelConfig.serviceProvider }],
  detailBreadcrumbItems: [
    {
      title: <Link to="/service-provider">{labelConfig.serviceProvider}</Link>,
    },
    { title: labelConfig.detailServiceProvider },
  ],

  productTypeData: [
    { label: "Placement", value: "placement" },
    { label: "Borrowing", value: "borrowing" },
  ],

  newBreadcrumbItems: [
    {
      title: <Link to="/service-provider">{labelConfig.serviceProvider}</Link>,
    },
    { title: labelConfig.newServiceProvider },
  ],
  editBreadcrumbItems: [
    {
      title: <Link to="/service-provider">{labelConfig.serviceProvider}</Link>,
    },
    { title: labelConfig.editServiceProvider },
  ],
  statusData: [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ],
  titleData: [
    { value: "mr", label: "Mr." },
    { value: "ms", label: "Ms." },
    { value: "mrs", label: "Mrs." },
  ],
  documentTypeData: [
    { value: "Proof of Identity", label: "Proof of Identity" },
    { value: "Proof of Address", label: "Proof of Address" },
    { value: "Utility Bills", label: "Utility Bills" },
    { value: "clientSignature", label: "Client Signature" },
    { value: "Other", label: "Other" },
  ],
  casaDetailBreadcrumbItems: [
    { title: <Link to="/cst0100">{labelConfig.serviceProvider}</Link> },
    { title: labelConfig.casaAccountDetail },
  ],
  recoverFromGuarantorloanDetailBreadcrumbItems: [
    { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanAccountDetail },
  ],
  newAddressBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailServiceProvider}</Link> },
    { title: labelConfig.newAddress },
  ],

  editAddressBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailServiceProvider}</Link> },
    { title: labelConfig.editAddress },
  ],
  yesOrNoData: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],

  pepStatusData: [
    { label: "TRUE", value: "true" },
    { label: "FALSE", value: "false" },
  ],
  riskRatingData: [
    { label: "HIGH", value: "high" },
    { label: "MEDIUM", value: "medium" },
    { label: "LOW", value: "low" },
  ],
  manageLoanBreadcrumbItems: [{ title: labelConfig.manageLoanAccount }],
  newLoanAccountsBreadcrumbs: [
    { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.newLoanAccount },
  ],
  newRelationshipBreadcrumbItems: [
    { title: <Link to="/cst0100">{labelConfig.serviceProvider}</Link> },
    { title: labelConfig.newRelationship },
  ],
  editRelationshipBreadcrumbItems: [
    { title: <Link to="/cst0100">{labelConfig.serviceProvider}</Link> },
    { title: labelConfig.editRelationship },
  ],
  manageSavingsAccountBreadcrumbItems: [
    { title: labelConfig.manageSavingsAccount },
  ],

  newSavingsAccountBreadcrumbItems: [
    { title: <Link to="/acc0102">{labelConfig.manageSavingsAccount}</Link> },
    { title: labelConfig.newSavingsAccount },
  ],

  detailSavingsAccountBreadcrumbItems: [
    { title: <Link to="/acc0102">{labelConfig.manageSavingsAccount}</Link> },
    { title: labelConfig.detailSavingsAccount },
  ],
  editSavingsAccountBreadcrumbItems: [
    { title: <Link to="/acc0102">{labelConfig.manageSavingsAccount}</Link> },
    { title: labelConfig.editSavingsAccount },
  ],
  destinationData: [
    { label: "own account", value: 1 },
    { label: "within bank", value: 2 },
  ],
  detailStandingInstructionBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailServiceProvider}</Link> },
    { title: labelConfig.detailStandingInstruction },
  ],

  editStandingInstructionBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailServiceProvider}</Link> },
    { title: labelConfig.editStandingInstruction },
  ],
  detailChargeBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailServiceProvider}</Link> },
    { title: labelConfig.detailCharge },
  ],
  payChargeBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailServiceProvider}</Link> },
    { title: labelConfig.payCharge },
  ],
  loanDetailBreadcrumbItems: [
    { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanAccountDetail },
  ],
  recoverFromGuarantorBreadcrumbItems: [
    // { title: <Link to="/detail-loan-account">{labelConfig.loanAccountDetail}</Link> },
    { title: labelConfig.recoverFromGuarantor },
  ],
  createGuarantorBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.createGuarantor },
  ],
  viewGuarantorsBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.viewGuarantors },
  ],
  loanScreenReportsBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanScreenReports },
  ],
  addLoanCollateralBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.addLoanCollateral },
  ],
  closeAsRescheduledBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.closeAsRescheduled },
  ],
  loanPrepaymentBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanPrepayment },
  ],
  loanRepaymentBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanRepayment },
  ],
  loanDisbursalBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanDisbursal },
  ],
  addLoanChargeBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.addLoanCharge },
  ],
  modifyApplicationBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.modifyApplication },
  ],
  approveLoanAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.approveLoanAcc },
  ],
  rejectLoanAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.rejectLoanAcc },
  ],
  assignLoanOfficerBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.assignLoanOfficer },
  ],
  foreClosureBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.foreClosure },
  ],
  makeRepaymentBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.makeRepayment },
  ],
  withdrawLoanAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdrawLoanAccount },
  ],
  journalEntriesBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.journalEntries },
  ],
  undoDisbursalBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.undoDisbursal },
  ],
  undoApprovalBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.undoApproval },
  ],
  waiveInterestBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.waiveInterest },
  ],
  rescheduleBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.reschedule },
  ],
  rescheduleRequestBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.rescheduleRequest },
  ],
  writeOffBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.writeOff },
  ],
  closeBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.closeLoanAccount },
  ],
  viewJournalEntriesBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.journalEntries },
  ],

  manageFixedDepositAccountBreadcrumbItems: [
    { title: labelConfig.manageFixedDepositAccount },
  ],
  newFixedDepositAccountBreadcrumbItems: [
    {
      title: <Link to="/acc0106">{labelConfig.manageFixedDepositAccount}</Link>,
    },
    { title: labelConfig.newFixedDepositAccount },
  ],
  detailFixedDepositAccountBreadcrumbItems: [
    {
      title: <Link to="/acc0106">{labelConfig.manageFixedDepositAccount}</Link>,
    },
    { title: labelConfig.detailFixedDepositAccount },
  ],
  editFixedDepositAccountBreadcrumbItems: [
    {
      title: <Link to="/acc0106">{labelConfig.manageFixedDepositAccount}</Link>,
    },
    { title: labelConfig.editFixedDepositAccount },
  ],
  universalSourceSysData: [
    { value: "selectOption", label: "Select Option" },
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ],
  performingStatusData: [{ value: "selectOption", label: "Select Option" }],
  universalHqlaData: [
    { value: "selectOption", label: "Select Option" },
    { value: "highQuality", label: "High Quality" },
    { value: "extremelyHighQuality", label: "Extremely High Quality" },
  ],
  typeOfClientAccForCassData: [
    { value: "selectOption", label: "Select Option" },
    { value: "clientBankAccount", label: "Client Bank Account" },
    { value: "clientTransactionAccount", label: "Client Transaction Account" },
  ],
  repaymentTypeData: [
    { value: "selectOption", label: "Select Option" },
    { value: "interestOnly", label: "Interest Only" },
    { value: "capitalOnly", label: "Capital Only" },
    { value: "capitalAndInterest", label: "Capital And Interest" },
  ],
  dayWeekMonthYearData: [
    { value: "days", label: "Days" },
    { value: "weeks", label: "Weeks" },
    { value: "months", label: "Months" },
    { value: "years", label: "Years" },
  ],
  maturityInstructionData: [
    { value: 100, label: "Withdraw Deposit" },
    { value: 200, label: "Transfer to Savings" },
    { value: 300, label: "Re-Invest Maturity Amount" },
    { value: 400, label: "Re-Invest Principal Only" },
  ],
  linkSavingsData: [{ value: "gbp", label: "GBP CURRENT ACCOUNT" }],

  //CASA FSCS ELIGIBLE
  fscsEligible: [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ],
  //CASA STATUS CODE
  statusCode: [
    { value: "blank", label: "Blank" },
    { value: "de", label: "DE" },
    { value: "lau", label: "LAU" },
    { value: "sf", label: "SF" },
    { value: "bra", label: "BRA" },
    { value: "dor", label: "DOR" },
    { value: "ga", label: "GA" },
  ],

  //CASA EXCLUSION IDENTIFIER
  exclusionIdentifier: [
    { value: "n/a", label: "N/A" },
    { value: "hmds", label: "HMDS" },
    { value: "legdis", label: "LEGDIS" },
    { value: "legdor", label: "LEGDOR" },
    { value: "ben", label: "BEN" },
  ],

  withdrawBalanceCloseAcc: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],
  isInterestPostingRequiredOnClosureDate: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],
  yesOrNo: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],

  postInterestAasOnBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.postInterestAasOn },
  ],
  depositBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.deposit },
  ],
  withdrawBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdraw },
  ],
  holdBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.hold },
  ],
  holdItemsBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.holdAccount },
  ],
  assignSavingsOfficerBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.assignSavingsOfficer },
  ],
  unassignSavingsOfficerBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.unassignSavingsOfficer },
  ],
  assignCurrentOfficerBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.assignCurrentOfficer },
  ],
  unassignCurrentOfficerBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.UnassignCurrentOfficer },
  ],
  addChargeBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.addCharge },
  ],
  viewJ: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.searchJournalEntries },
  ],
  detailJournalEntryBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.detailJournalEntry },
  ],

  //SAVINGS ACCOUNT
  withdrawSavingsAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdrawSavingsAccount },
  ],

  // CURRENT ACCOUNT
  manageCurrentAccountBreadcrumbItems: [
    { title: labelConfig.manageCurrentAccount },
  ],
  newCurrentAccountBreadcrumbItems: [
    { title: <Link to="/acc0101">{labelConfig.manageCurrentAccount}</Link> },
    { title: labelConfig.newCurrentAccount },
  ],
  detailCurrentAccountBreadcrumbItems: [
    { title: <Link to="/acc0101">{labelConfig.manageCurrentAccount}</Link> },
    { title: labelConfig.detailCurrentAccount },
  ],
  editCurrentAccountBreadcrumbItems: [
    { title: <Link to="/acc0101">{labelConfig.manageCurrentAccount}</Link> },
    { title: labelConfig.editCurrentAccount },
  ],
  CurrentAccountJournalEntriesBreadcrumbItems: [
    // {
    //   title: (
    //     <Link to="/detail-current-account">
    //       {labelConfig.detailCurrentAccount}
    //     </Link>
    //   ),
    // },
    { title: labelConfig.manageJournalEntries },
  ],
  CurrentAccountUndoApprovalBreadcrumbItems: [
    // { title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.undoApprovalCurrentAcc },
  ],
  rejectCurrentAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.rejectCurrentAccount },
  ],
  withdrawByApplicantCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdrawCurrentAccount },
  ],
  unassignStaffCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.UnassignCurrentOfficer },
  ],
  addChargesCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.addChargesCurrentAcc },
  ],
  editKycCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.editFscsData },
  ],
  viewManagedAccountDetailsCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.viewManagedAccountDetails },
  ],
  editManageCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.editManageCurrentAcc },
  ],
  // END OF CURRENT ACCOUNT

  // TERM DEPOSIT ACCOUNT
  manageDepositBreadcrumbItems: [{ title: labelConfig.manageDepositAccount }],
  newDepositAccountsBreadcrumbs: [
    { title: <Link to="/acc0105">{labelConfig.manageDepositAccount}</Link> },
    { title: labelConfig.newDepositAccount },
  ],

  filterOptions: [
    {
      value: " ",
      label: "All",
    },
    {
      value: true,
      label: "Manual Entries",
    },
    {
      value: false,
      label: "System Entries",
    },
  ],
  rejectSavingsAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.rejectSavingsAccount },
  ],
  savingsAccountUndoApprovalBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.undoApprovalSavingsAcc },
  ],
  addSavingsAccountChargeBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.addCharge },
  ],

  // FIXED DEPOSIT ACCOUNT
  addFixedDepositChargeBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.addFixedDepositCharge },
  ],
  approveFixedDepositAccBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.approveFixedDepositAcc },
  ],
  manageAccountDetailsBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.manageAccountDetails },
  ],

  undoApprovalFixedDepositAccBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.undoApprovalFixedDepositAcc },
  ],

  // FIXED DEPOSIT ACCOUNT
  addFixedDepositChargeBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.addFixedDepositCharge },
  ],
  approveFixedDepositAccBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.approveFixedDepositAcc },
  ],
  rejectFixedDepositAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.rejectFixedDepositAccount },
  ],

  closeSavingsBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.closeSavingsAcc },
  ],
  prematureCloseFixedDepositAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.prematureCloseFixedDeposit },
  ],
  closeFixedDepositAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.closeFixedDeposit },
  ],
  withdrawFixedDepositAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdrawFixedDepositApp },
  ],

  // RECURRING DEPOSIT
  manageRecurringDepositAccountBreadcrumbItems: [
    { title: labelConfig.manageRecurringDepositAccount },
  ],

  detailRecurringDepositAccountBreadcrumbItems: [
    {
      title: (
        <Link to="/acc0107">{labelConfig.manageRecurringDepositAccount}</Link>
      ),
    },
    { title: labelConfig.detailRecurringDepositAccount },
  ],
  approveRecurringDepositAccBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.approveRecurringDepositAcc },
  ],
  newRecurringDepositBreadcrumbItems: [
    {
      title: (
        <Link to="/acc0107">{labelConfig.manageRecurringDepositAccount}</Link>
      ),
    },
    { title: labelConfig.newRecurringDepositAccount },
  ],
  recurringDepositAccUndoApprovalBreadcrumbItems: [
    // { title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.undoApprovalRecurringDepositAcc },
  ],
  recurringDepositAccActivationBreadcrumbItems: [
    // { title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.activateRecurringDeposiAcc },
  ],
  recurringDepositAccRejectBreadcrumbItems: [
    // { title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.RejectRecurringDepositAcc },
  ],
  recurringDepositAccAddChargesBreadcrumbItems: [
    // { title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.addChargesRecurringDepositAcc },
  ],
  recurringDepositAccWithdrawBreadcrumbItems: [
    // { title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.withdrawFromRecurringDepositAcc },
  ],
  prematureCloseRecurringDepositAccountBreadcrumbItems: [
    // { title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.prematureCloseRecurringDeposit },
  ],
  depositRecurringDepositAccountBreadcrumbItems: [
    // { title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.depositRecurringDepositAcc },
  ],
  withdrawnByApplicantRecurringDepositAccountBreadcrumbItems: [
    // { title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.withdrawRecurringDepositApplication },
  ],

  manageMoneyMarketBreadcrumbItems: [
    { title: labelConfig.manageMoneyMarketAccount },
  ],

  newMoneyMarketAccountBreadcrumbs: [
    {
      title: <Link to="/acc0108">{labelConfig.manageMoneyMarketAccount}</Link>,
    },
    { title: labelConfig.newMoneyMarketAccount },
  ],

  manageStandingInstructionsBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.manageStandingInstructons },
  ],
  newStandingInstructionsBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.newStandingInstruction },
  ],
  trueOrFalseData: [
    { label: "True", value: true },
    { label: "False", value: false },
  ],
  kycStatusOptions: [
    {
      id: 1,
      code: "verified",
      value: "VERIFIED",
    },
    {
      id: 2,
      code: "unverified",
      value: "UNVERIFIED",
    },
  ],
  manageLoanApprovalBreadcrumbItems: [
    { title: labelConfig.manageLoanApproval },
  ],
  viewLoanApprovalBreadcrumbItems: [
    {
      title: <Link to="/loan-approval">{labelConfig.manageLoanApproval}</Link>,
    },
    { title: labelConfig.loanAccountDetail },
  ],

  // STAND ALONE DATA
  customerStatusOptions: [
    { key: 1, value: "status", label: "All Status" },
    { key: 2, value: "active", label: "Active" },
    { key: 3, value: "closed", label: "Closed" },
    {
      key: 4,
      value: "pending",
      label: "Pending Approval",
    },
  ],
  // ACCOUNTS STATUS  DATA
  accountStatusOptions: [
    { key: 1, value: "status", label: "All Status" },
    { key: 2, value: "active", label: "Active" },
    { key: 3, value: "closed", label: "Closed" },
    {
      key: 4,
      value: "submitted and pending approval",
      label: "Pending Approval",
    },
    { key: 5, value: "rejected", label: "Rejected" },
    { key: 6, value: "Withdrawn by applicant", label: "Withdrawn" },
    { key: 8, value: "approved", label: "Approved" },
    { key: 9, value: "matured", label: "Matured" },
    { key: 10, value: "premature closed", label: "Early Termination" },
  ],
  loanAccountStatusOptions: [
    { key: 1, value: "status", label: "All Status" },
    { key: 2, value: "active", label: "Active" },
    {
      key: 3,
      value: "Closed (obligations met)",
      label: "Closed (obligations met)",
    },
    { key: 4, value: "Closed (rescheduled)", label: "Closed (rescheduled)" },
    { key: 5, value: "Closed (written off)", label: "Closed (Written Off)" },
    {
      key: 6,
      value: "submitted and pending approval",
      label: "Pending Approval",
    },
    { key: 7, value: "rejected", label: "Rejected" },
    { key: 8, value: "Withdrawn by applicant", label: "Withdrawn" },
    { key: 9, value: "approved", label: "Approved" },
    { key: 10, value: "overpaid", label: "Overpaid" },
  ],
  agentTypeData: [
    { key: 1, value: "SUPER_AGENT", label: "SUPER AGENT" },
    { key: 2, value: "AGENT", label: "AGENT" },
    { key: 3, value: "MERCHANT", label: "MERCHANT" },
  ],
};
